<template lang="pug">
.be-link-picker(@mousedown.stop @click.stop @keydown.stop)

  el-radio-group.be-lp-tabs(v-model="localType" size="mini")
    el-radio-button(v-for="t in linkTypes" :key="t.key" :label="t.key") {{ t.label }}

  .be-cd-sep

  .be-lp-body
    template(v-if="localType === 'internal'")
      Treeselect(
        v-model="localMenuItemId"
        placeholder="Seite auswählen ..."
        :multiple="false"
        :options="pageOptions"
        :default-expand-level="Infinity"
        :close-on-select="true"
        :open-on-focus="true"
        :searchable="true"
        :normalizer="node => ({ label: node.title, ...node })"
        :clearable="true"
        :always-open="false"
      )

    template(v-else-if="localType === 'external'")
      .be-lp-input-row
        el-input(v-model="localHref" placeholder="https://..." size="mini" clearable)
      .be-lp-check-row
        el-checkbox(v-model="localTargetBlank" size="mini") In neuem Tab öffnen

    template(v-else-if="localType === 'mailto'")
      .be-lp-input-row
        el-input(v-model="localHref" placeholder="email@beispiel.de" size="mini" clearable)

    template(v-else-if="localType === 'tel'")
      .be-lp-input-row
        el-input(v-model="localHref" placeholder="+49 123 456789" size="mini" clearable)

    template(v-else-if="localType === 'media'")
      .be-lp-media-row
        el-input(v-model="localHref" placeholder="Keine Datei ausgewählt" size="mini" :readonly="true")
        el-button(size="mini" plain icon="el-icon-fa-folder-open fas" @click.stop="mediaOpen = true") Wählen

  image-library-dialog(
    :visible.sync="mediaOpen"
    selection-type="file"
    @select="onMediaSelect"
  )

  template(v-if="hasLink")
    .be-cd-sep
    .be-lp-clear-row
      button.be-lp-clear-btn(@click.stop="clear")
        i.el-icon-fa-unlink.fas
        span Verknüpfung entfernen
</template>

<script>
import _ from 'lodash'
import NestedSet from '@/nested-set-lib'
import Treeselect from '@riophae/vue-treeselect'
import ImageLibraryDialog from './ImageLibraryDialog'
import { useSetupStore } from '@/stores'

export default {
    name: 'BannerLinkPicker',
    components: { Treeselect, ImageLibraryDialog },
    props: {
        value: { type: Object, default: () => ({}) },
        options: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            mediaOpen: false,
            linkTypes: [
                { key: 'external', label: 'Extern' },
                { key: 'internal', label: 'Intern' },
                { key: 'mailto',   label: 'E-Mail' },
                { key: 'tel',      label: 'Telefon' },
                { key: 'media',    label: 'Mediathek' },
            ],
        }
    },
    computed: {
        setupStore() { return useSetupStore() },
        activeCms() { return this.setupStore.activeCms },

        pageOptions() {
            let menus = _.get(this.activeCms, 'config.template.menus', [])
            menus = _.cloneDeep(menus).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
            const menuOptions = _.get(this.options, 'menu.items') || []
            const visibleOptgroups = menuOptions.filter(el => el.menuItems.length).length > 1
            let tree = []
            menus.forEach(menu => {
                const menuOption = _.find(menuOptions, { key: menu.key })
                const items = _.get(menuOption, 'menuItems', [])
                if (items.length) {
                    const optgroup = {
                        id: `optgroup-${menuOption.id}`,
                        title: menuOption.name,
                        isDisabled: true,
                        optgroup: true,
                    }
                    if (visibleOptgroups) tree.push(optgroup)
                    tree = [...tree, ...NestedSet.createTree(items)]
                }
            })
            return tree
        },

        localType: {
            get() { return _.get(this.value, 'type') || 'external' },
            set(v) { this.emit({ type: v, href: '', menuItem: null, target: '_self' }) },
        },
        localHref: {
            get() { return _.get(this.value, 'href') || '' },
            set(v) { this.emit({ href: v }) },
        },
        localTargetBlank: {
            get() { return _.get(this.value, 'target') === '_blank' },
            set(v) { this.emit({ target: v ? '_blank' : '_self' }) },
        },
        localMenuItemId: {
            get() { return _.get(this.value, 'menuItem.id') || null },
            set(id) {
                const menuOptions = _.get(this.options, 'menu.items') || []
                let found = null
                menuOptions.forEach(mo => {
                    const item = (mo.menuItems || []).find(i => i.id === id)
                    if (item) found = item
                })
                this.emit({ menuItem: found ? { id: found.id, title: found.title, path: found.path } : null })
            },
        },
        hasLink() {
            return this.localType === 'internal' ? !!this.localMenuItemId : !!this.localHref
        },
    },
    methods: {
        emit(patch) {
            this.$emit('input', { ...this.value, ...patch })
        },
        onMediaSelect(file) {
            this.emit({ href: file.url })
            this.mediaOpen = false
        },
        clear() {
            this.$emit('input', {})
        },
    },
}
</script>

<style lang="sass">
@import '~@riophae/vue-treeselect/dist/vue-treeselect.css'

.be-link-picker
    padding: 10px
    display: flex
    flex-direction: column
    gap: 0

    .be-lp-tabs
        display: flex
        .el-radio-button
            flex: 1
            .el-radio-button__inner
                width: 100%
                padding: 5px 6px
                font-size: 12px

    .be-cd-sep
        height: 1px
        background: #f3f4f6
        margin: 6px 0

    .be-lp-body
        display: flex
        flex-direction: column
        gap: 2px

        .be-cd-label
            font-size: 10px
            font-weight: 600
            color: #9ca3af
            text-transform: uppercase
            letter-spacing: 0.04em
            margin-bottom: 0
            display: block

        .be-lp-input-row
            .el-input
                width: 100%

        .be-lp-check-row
            margin-top: 2px

        .be-lp-media-row
            display: flex
            gap: 6px
            align-items: center
            .el-input
                flex: 1

        .vue-treeselect
            font-size: 12px
            width: 100%
            .vue-treeselect__control
                height: 28px
                border-color: #dcdfe6
            .vue-treeselect__placeholder,
            .vue-treeselect__single-value
                line-height: 26px
                font-size: 12px
            .vue-treeselect__menu-container
                width: 100% !important

    .be-lp-clear-row
        display: flex

    .be-lp-clear-btn
        display: flex
        align-items: center
        gap: 5px
        font-size: 12px
        color: #ef4444
        background: none
        border: none
        cursor: pointer
        padding: 0
        &:hover
            color: #dc2626
</style>
